export default __webpack_public_path__ + "static/media/coral-left-type-2.859064e6.gif";